/*
  Enabled Debugging redux state for the browsers.
  shall be removed before pushing to production
*/
import { createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
import { createEpicMiddleware } from 'redux-observable';
// DO NOT REMOVE
import * as ax from 'app/employer/config/axios-interceptor';

import { getLoggedInUserDetails } from 'redux/auth/authService';
import { rootReducer } from '../reducers/index';
import { extractLoggedInUserPartnerDetails } from '../auth/authActions';

const epicMiddleware = createEpicMiddleware();

const middlewares = [thunk, epicMiddleware];

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const store = createStore(
   rootReducer,
   composeEnhancers(
      applyMiddleware(...middlewares),
   ),
);

store.dispatch(getLoggedInUserDetails());
store.dispatch(extractLoggedInUserPartnerDetails());

export default store;
